import { createClient } from "@supabase/supabase-js";

import { runtimeConfig } from "./config";

const config = runtimeConfig();

export const isAuthConfigured = Boolean(
  config.supabaseUrl && config.supabaseAnonKey,
);

export const supabase = isAuthConfigured
  ? createClient(config.supabaseUrl, config.supabaseAnonKey, {
      auth: {
        persistSession: true,
        autoRefreshToken: true,
        detectSessionInUrl: true,
      },
    })
  : null;

export { config };
